import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './SearchBar.css';

interface SearchBarProps {
  value: string;
  onChange: (q: string) => void;
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  const { t } = useTranslation();
  return (
    <div className="sb-wrap">
      <Search size={18} className="sb-icon" aria-hidden />
      <input
        type="search"
        className="sb-input"
        placeholder={t('feed.searchPlaceholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={t('feed.searchPlaceholder')}
      />
      {value.length > 0 && (
        <button
          type="button"
          className="sb-clear"
          onClick={() => onChange('')}
          aria-label={t('common.close', { defaultValue: 'Очистить' })}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
